import { useGetDefaultRelease } from '@upright/ui/api/model/releases';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDefaultModelVersionAndRelease as _setDefaultModelVersionAndRelease,
  setModelVersionAndRelease,
} from '../../../untidy/redux/actions/actions';
import { getIsModelVersionOrReleaseUninitialized } from '../../../untidy/redux/selectors';

/**
 * Hook that fetches public model version and
 * stores it to redux state
 *
 * (unless in mapper search)
 */

export function useLoadDefaultVersionAndRelease() {
  const { data } = useGetDefaultRelease();
  const setDefaultModelVersionAndRelease = useSetDefaultModelVersionAndRelease();

  useEffect(() => {
    if (data) {
      const { number, resolvedProductTarget } = data;
      setDefaultModelVersionAndRelease(resolvedProductTarget, number);
    }
  }, [data, setDefaultModelVersionAndRelease]);
  return data;
}

export function useSetDefaultModelVersionAndRelease() {
  const shouldInitialize = useSelector(getIsModelVersionOrReleaseUninitialized);
  const dispatch = useDispatch();
  return useMemo(() => {
    if (shouldInitialize) {
      return (version: string, release: string) => {
        dispatch(_setDefaultModelVersionAndRelease(version, release));
        dispatch(setModelVersionAndRelease(version, release));
      };
    } else {
      return (version: string, release: string) => {
        dispatch(_setDefaultModelVersionAndRelease(version, release));
      };
    }
  }, [shouldInitialize, dispatch]);
}
